import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=2c36c8e7&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/forms.css?vue&type=style&index=0&id=2c36c8e7&prod&scoped=true&lang=css&external"
import style1 from "./Form.vue?vue&type=style&index=1&id=2c36c8e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c36c8e7",
  null
  
)

export default component.exports